import { createAction, props } from "@ngrx/store";
import { ISkillGroup } from "@skills-app/models/skillGroup";
import { ISkillNode } from "@skills-app/models/skillNode";

const prefix = "[Skill API]";

export const loadSkillsSuccess = createAction(
  `${prefix} Load Skills Success`,
  props<{ skills: ISkillNode[] }>(),
);
export const loadSkillsFailure = createAction(`${prefix} Load Skills Failure`);

export const loadSkillsByRelatedSkillsThresholdSuccess = createAction(
  `${prefix} Load Skills By Related Skills Threshold Success`,
  props<{ skills: ISkillNode[] }>(),
);
export const loadSkillsByRelatedSkillsThresholdFailure = createAction(
  `${prefix} Load Skills By Related Skills Threshold Failure`,
);

export const loadSelectedRelatedSkillsSuccess = createAction(
  `${prefix} Load Selected Related Skills Success`,
  props<{ skills: ISkillNode[] }>(),
);
export const loadSelectedRelatedSkillsFailure = createAction(
  `${prefix} Load Selected Related Skills Failure`,
);

export const loadSearchRelatedSkillsSuccess = createAction(
  `${prefix} Load Search Related Skills Success`,
  props<{ originalSkill: ISkillNode; relatedSkills: ISkillNode[] }>(),
);
export const loadSearchRelatedSkillsFailure = createAction(
  `${prefix} Load Search Related Skills Failure`,
);

export const loadSelectedSkillAliasesSuccess = createAction(
  `${prefix} Load Selected Skill Aliases Success`,
  props<{ skills: ISkillNode[] }>(),
);
export const loadSelectedSkillAliasesFailure = createAction(
  `${prefix} Load Selected Skill Aliases Failure`,
);

export const skillAdded = createAction(
  `${prefix} Skill Added`,
  props<{ createdSkill: ISkillNode }>(),
);
export const addSkillError = createAction(`${prefix} Add Skill Error`);

export const skillEdited = createAction(`${prefix} Skill Edited`);
export const editSkillError = createAction(`${prefix} Edit Skill Error`);

export const skillDeleted = createAction(`${prefix} Skill Deleted`);
export const deleteSkillError = createAction(`${prefix} Delete Skill Error`);

export const loadSkillsForSelectedSearchSuccess = createAction(
  `${prefix} Load Skills For Selected Search Success`,
  props<{ skills: ISkillNode[] }>(),
);
export const loadSkillsForSelectedSearchFailure = createAction(
  `${prefix} Load Skills For Selected Search Failure`,
);

export const relatedSkillAdded = createAction(`${prefix} Related Skill Added`);
export const addRelatedSkillFailure = createAction(
  `${prefix} Add Related Skill Failure`,
);

export const relatedSkillDeleted = createAction(
  `${prefix} Related Skill Deleted`,
);
export const deleteRelatedSkillFailure = createAction(
  `${prefix} Delete Related Skill Failure`,
);
export const linkToSkillGroup = createAction(
  `${prefix} Link to Skill Group Request`,
  props<{ skill: ISkillNode; skillGroup: ISkillGroup }>(),
);
export const linkToSkillGroupSuccess = createAction(
  `${prefix} Link to Skill Group Success`,
);
export const linkToSkillGroupError = createAction(
  `${prefix} Link to Skill Group Error`,
);

export const deleteLinkToSkillGroup = createAction(
  `${prefix} Deletion of Skill Group Link Request`,
  props<{ skill: ISkillNode; skillGroup: ISkillGroup }>(),
);
export const deleteLinkToSkillGroupSuccess = createAction(
  `${prefix} Deletion of Skill Group Link Success`,
);
export const deleteLinkToSkillGroupError = createAction(
  `${prefix} Deletion of Skill Group Link Error`,
);
